/**
 * Freshness halo tracker — O(M) replacement for the O(N) per-frame rbush.search.
 * Strokes are tracked by ID with a client-side receivedAt timestamp, so the halo
 * fade is immune to server/client clock drift (R4-P1-3).
 *
 * Only strokes arriving via WS stroke:commit are marked fresh; bulk-loaded
 * historical strokes are not.
 */
const FRESH_MS = 6000;

const fresh = new Map<number, { receivedAt: number; expiresAt: number }>();

export function markFresh(strokeId: number) {
  const now = Date.now();
  fresh.set(strokeId, { receivedAt: now, expiresAt: now + FRESH_MS });
}

export interface FreshEntry {
  strokeId: number;
  fade: number;
}

export function getFresh(): FreshEntry[] {
  const now = Date.now();
  const result: FreshEntry[] = [];
  for (const [id, entry] of fresh) {
    if (now >= entry.expiresAt) {
      fresh.delete(id);
      continue;
    }
    result.push({ strokeId: id, fade: 1 - (now - entry.receivedAt) / FRESH_MS });
  }
  return result;
}

export function clearFresh() {
  fresh.clear();
}
